var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useContext, useEffect, useState } from 'react';
export var COINGECKO_POOL_INTERVAL = 1000 * 60; // 60 sec
export var COINGECKO_API = 'https://api.coingecko.com/api/v3/';
export var COINGECKO_COIN_PRICE_API = "".concat(COINGECKO_API, "simple/price");
export var solToUSD = function () { return __awaiter(void 0, void 0, void 0, function () {
    var url, resp;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(COINGECKO_COIN_PRICE_API, "?ids=solana&vs_currencies=usd");
                return [4 /*yield*/, window.fetch(url).then(function (resp) { return resp.json(); })];
            case 1:
                resp = _a.sent();
                return [2 /*return*/, resp.solana.usd];
        }
    });
}); };
export var altSplToUSD = function (cgTokenName) { return __awaiter(void 0, void 0, void 0, function () {
    var cg_spl_token_id, url, resp;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!process.env.NEXT_SPL_TOKEN_MINTS ||
                    process.env.NEXT_SPL_TOKEN_MINTS.length == 0)
                    return [2 /*return*/, 0];
                cg_spl_token_id = cgTokenName
                    ? cgTokenName.toLowerCase().split(' ').join('-')
                    : process.env.NEXT_CG_SPL_TOKEN_ID || '';
                url = "".concat(COINGECKO_COIN_PRICE_API, "?ids=").concat(cg_spl_token_id, "&vs_currencies=usd");
                return [4 /*yield*/, window.fetch(url).then(function (resp) { return resp.json(); })];
            case 1:
                resp = _b.sent();
                //console.log("[--P]Processing", cgTokenName, resp)
                return [2 /*return*/, (_a = resp[cg_spl_token_id]) === null || _a === void 0 ? void 0 : _a.usd];
        }
    });
}); };
var CoingeckoContext = React.createContext(null);
export function CoingeckoProvider(_a) {
    var _this = this;
    var _b = _a.children, children = _b === void 0 ? null : _b;
    var _c = __read(useState(0), 2), solPrice = _c[0], setSolPrice = _c[1];
    var _d = __read(useState([]), 2), allSplPrices = _d[0], setAllSplPrices = _d[1];
    useEffect(function () {
        var timerId = 0;
        var queryPrice = function () { return __awaiter(_this, void 0, void 0, function () {
            var solprice, subscribedTokenMints, subscribedTokenIDS, splPricePromises, _loop_1, i, allSplPrices;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, solToUSD()];
                    case 1:
                        solprice = _a.sent();
                        setSolPrice(solprice);
                        subscribedTokenMints = process.env.NEXT_SPL_TOKEN_MINTS
                            ? process.env.NEXT_SPL_TOKEN_MINTS.split(',')
                            : [];
                        subscribedTokenIDS = process.env.NEXT_CG_SPL_TOKEN_IDS
                            ? process.env.NEXT_CG_SPL_TOKEN_IDS.split(',')
                            : [];
                        splPricePromises = [];
                        _loop_1 = function (i) {
                            var splName = subscribedTokenIDS[i];
                            var splMint = subscribedTokenMints[i];
                            //console.log("[--P]PROCESSING TOKEN",i,  splName, splMint)
                            splPricePromises.push((function () { return __awaiter(_this, void 0, void 0, function () {
                                var splPrice, e_1;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, altSplToUSD(splName)];
                                        case 1:
                                            splPrice = _a.sent();
                                            //console.log("[--P]PRICE", splPrice)
                                            return [2 /*return*/, {
                                                    tokenMint: splMint,
                                                    tokenName: splName,
                                                    tokenPrice: splPrice,
                                                }];
                                        case 2:
                                            e_1 = _a.sent();
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); })());
                        };
                        for (i = 0; i < subscribedTokenMints.length; i++) {
                            _loop_1(i);
                        }
                        return [4 /*yield*/, Promise.all(splPricePromises)];
                    case 2:
                        allSplPrices = _a.sent();
                        setAllSplPrices(allSplPrices.filter(Boolean));
                        //console.log("[--P]SUBSCRIBED TOKENS", allSplPrices)
                        startTimer();
                        return [2 /*return*/];
                }
            });
        }); };
        var startTimer = function () {
            timerId = window.setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    queryPrice();
                    return [2 /*return*/];
                });
            }); }, COINGECKO_POOL_INTERVAL);
        };
        queryPrice();
        return function () {
            clearTimeout(timerId);
        };
    }, [setSolPrice, setAllSplPrices]);
    return (React.createElement(CoingeckoContext.Provider, { value: { solPrice: solPrice, allSplPrices: allSplPrices } }, children));
}
export var useCoingecko = function () {
    var context = useContext(CoingeckoContext);
    return context;
};
export var useSolPrice = function () {
    var solPrice = useCoingecko().solPrice;
    return solPrice;
};
export var useAllSplPrices = function () {
    var allSplPrices = useCoingecko().allSplPrices;
    return allSplPrices;
};
